export default {
    namespaced:true,
    state:{
        projectId:"",
        sign_name:"",
        checkName:"",
        isFinished:false,
        processData:{},
        catelogueData:[],
        evaluationData:{

        },
        baseData:{

        },
        settings_word:{
            para_inspect_len: 30,
            para_text_len: 5,
            para_skip_word_num: 3,
            table_inspect_len: 30,
            table_text_len: 5,
            table_skip_word_num: 3
        },
        serviceInfo:{},
        hasImg:false,
        hasAuthor:false,
        hasPhone:false,
        hasPara:false
    },
    mutations:{
        changeSettings(state,settings){
            state.settings_word = settings;
        },
        set_projectId_word(state,projectId){
            state.projectId = projectId
        },
        set_signName_word(state,sign_name){
            state.sign_name = sign_name;
        },
        set_checkName_word(state,checkName){
            state.checkName = checkName || '';
        },
        setProcessData(state,processData){
            state.processData = processData;
        },
        setCatelogueData(state,data){
            state.catelogueData = data;
        },
        setEvaluationData(state,data){
            state.evaluationData = data;
        },
        setBaseData(state,data){
            state.baseData = data;
        },
        setFinished(state,data){
            state.isFinished = data;
        },
        setHasImg(state,hasImg){
            state.hasImg = hasImg
        },
        setHasAuthor(state,hasAuthor){
            state.hasAuthor = hasAuthor
        },
        setHasPhone(state,hasPhone){
            state.hasPhone = hasPhone
        },
        setHasPara(state,hasPara){
            state.hasPara = hasPara
        },
        setServiceInfo(state,info){
            state.serviceInfo = info;
        }
    }
}
